module.exports = __webpack_public_path__ + "img/HEART SHADES BW.e7a9efa.svg";